import React, { useState, useEffect } from 'react';
import { Search, Trash2, Edit, Plus, Save, X, Camera, Maximize2, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
const DelegateManagement = () => {
  const navigate = useNavigate();
  const [delegates, setDelegates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch] = useState('');
  const [formData, setFormData] = useState({
    DelegateName: '',
    Title: '',
    PhoneNumber: '',
    Address: '',
    Email: '',
    Notes: '',
    DelegateImage: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showNotes, setShowNotes] = useState(null); // للملاحظات

  useEffect(() => {
    fetchDelegates();
  }, []);

  const fetchDelegates = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/delegates`);
      if (!response.ok) {
        throw new Error('فشل في جلب بيانات المناديب');
      }
      const data = await response.json();
      setDelegates(data);
    } catch (error) {
      console.error('خطأ في جلب المناديب:', error);
      alert('حدث خطأ في جلب بيانات المناديب');
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1024 * 1024) {
        alert('حجم الصورة يجب أن يكون أقل من 1 ميجابايت');
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          DelegateImage: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingId 
        ? `${config.API_BASE_URL}/api/delegates/${editingId}`
        : `${config.API_BASE_URL}/api/delegates`;
        
      const method = editingId ? 'PUT' : 'POST';
      
      console.log('البيانات المرسلة:', formData); // إضافة هذا السطر للتحقق

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      // للتأكد من استجابة الخادم
      const responseData = await response.json();
      console.log('استجابة الخادم:', responseData); // إضافة هذا السطر للتحقق

      if (!response.ok) {
        throw new Error(responseData.error || 'حدث خطأ في العملية');
      }

      alert(editingId ? 'تم تحديث المندوب بنجاح' : 'تم إضافة المندوب بنجاح');
      await fetchDelegates();
      resetForm();
    } catch (error) {
      console.error('خطأ:', error);
      alert('حدث خطأ: ' + error.message);
    }
};

  const handleEdit = (delegate) => {
    setFormData({
      DelegateName: delegate.DelegateName,
      Title: delegate.Title || '',
      PhoneNumber: delegate.PhoneNumber || '',
      Address: delegate.Address || '',
      Email: delegate.Email || '',
      Notes: delegate.Notes || '',
      DelegateImage: delegate.DelegateImage || ''
    });
    setEditingId(delegate.DelegateID);
    setShowForm(true);
  };

  const handleDelete = async (delegateId) => {
    if (window.confirm('هل أنت متأكد من حذف هذا المندوب؟')) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/api/delegates/${delegateId}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          throw new Error('فشل في حذف المندوب');
        }

        alert('تم حذف المندوب بنجاح');
        fetchDelegates();
      } catch (error) {
        console.error('خطأ في حذف المندوب:', error);
        alert('حدث خطأ في حذف المندوب');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      DelegateName: '',
      Title: '',
      PhoneNumber: '',
      Address: '',
      Email: '',
      Notes: '',
      DelegateImage: ''
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const goBack = () => {
    navigate('/');
  };

  const filteredDelegates = delegates.filter(delegate =>
    delegate.DelegateName?.toLowerCase().includes(search.toLowerCase()) ||
    delegate.Title?.toLowerCase().includes(search.toLowerCase()) ||
    delegate.PhoneNumber?.toLowerCase().includes(search.toLowerCase()) ||
    delegate.Email?.toLowerCase().includes(search.toLowerCase()) ||
    delegate.Notes?.toLowerCase().includes(search.toLowerCase())
  );

  // دالة لتنسيق نص الملاحظات
  const truncateNotes = (notes) => {
    if (!notes) return '-';
    return notes.length > 30 ? notes.substring(0, 30) + '...' : notes;
  };

  return (
    <div className="min-h-screen bg-gray-100 py-3 md:py-6 overflow-x-hidden" dir="rtl">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="bg-white rounded-2xl md:rounded-lg shadow-md p-4 md:p-6 mb-4 md:mb-6">
          <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">
            <div>
              <p className="md:hidden text-xs text-blue-600 font-semibold mb-1">مسار / المناديب</p>
              <h1 className="text-xl md:text-3xl font-bold text-gray-900">إدارة المناديب</h1>
              <p className="md:hidden text-sm text-gray-500 mt-1">إجمالي {filteredDelegates.length} مندوب</p>
            </div>
            <button 
              onClick={goBack}
              className="bg-gray-600 hover:bg-gray-700 text-white px-4 md:px-6 py-3 md:py-2.5 rounded-xl md:rounded-lg transition duration-200 ease-in-out md:transform md:hover:scale-105 w-full md:w-auto"
            >
              العودة للرئيسية
            </button>
          </div>
        </div>
        {/* Actions Bar */}
       <div className="bg-white rounded-2xl md:rounded-lg shadow-md p-4 md:p-6 mb-4 md:mb-6">
         <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">
           <button 
             className="bg-blue-600 hover:bg-blue-700 text-white px-4 md:px-6 py-3 md:py-2.5 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200 ease-in-out md:transform md:hover:scale-105 w-full md:w-auto font-semibold"
             onClick={() => setShowForm(true)}
           >
             <Plus size={20} />
             إضافة مندوب جديد
           </button>
           <div className="relative w-full md:w-96">
             <Search className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
             <input
               type="text"
               placeholder="البحث في المناديب..."
               value={search}
               onChange={(e) => setSearch(e.target.value)}
               className="w-full border border-gray-300 rounded-xl md:rounded-lg py-3 md:py-2.5 px-10 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
             />
           </div>
         </div>
       </div>

       {/* Delegates Table */}
       <div className="bg-white rounded-2xl md:rounded-lg shadow-md overflow-hidden">
         <div className="hidden md:block overflow-x-auto">
           <table className="w-full border-collapse">
             <thead>
               <tr className="bg-gray-50">
                 <th className="px-6 py-4 border-b border-gray-200 text-right">صورة المندوب</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">اسم المندوب</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">اللقب</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">رقم الهاتف</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">العنوان</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">البريد الإلكتروني</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">ملاحظات</th>
                 <th className="px-6 py-4 border-b border-gray-200 text-right">الإجراءات</th>
               </tr>
             </thead>
             <tbody>
               {filteredDelegates.map((delegate) => (
                 <tr key={delegate.DelegateID} className="hover:bg-gray-50 transition duration-150">
                   <td className="px-6 py-4 border-b border-gray-200">
                     {delegate.DelegateImage ? (
                       <div className="relative group">
                         <img 
                           src={delegate.DelegateImage} 
                           alt="صورة المندوب"
                           className="w-28 h-28 object-cover rounded-lg shadow-md cursor-pointer transition-transform duration-200 transform hover:scale-105"
                           onClick={() => handleImageClick(delegate.DelegateImage)}
                         />
                         <button
                           className="absolute top-2 right-2 bg-black bg-opacity-50 text-white p-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                           onClick={() => handleImageClick(delegate.DelegateImage)}
                         >
                           <Maximize2 size={16} />
                         </button>
                       </div>
                     ) : (
                       <div className="w-28 h-28 bg-gray-100 rounded-lg shadow-inner flex items-center justify-center">
                         <Camera size={36} className="text-gray-400" />
                       </div>
                     )}
                   </td>
                   <td className="px-6 py-4 border-b border-gray-200 font-medium">{delegate.DelegateName}</td>
                   <td className="px-6 py-4 border-b border-gray-200 text-gray-600">{delegate.Title || '-'}</td>
                   <td className="px-6 py-4 border-b border-gray-200">{delegate.PhoneNumber || '-'}</td>
                   <td className="px-6 py-4 border-b border-gray-200">{delegate.Address || '-'}</td>
                   <td className="px-6 py-4 border-b border-gray-200">{delegate.Email || '-'}</td>
                   <td className="px-6 py-4 border-b border-gray-200">
                     <div className="flex items-center gap-2">
                       <span className="truncate max-w-[150px]">{truncateNotes(delegate.Notes)}</span>
                       {delegate.Notes && (
                         <button
                           onClick={() => setShowNotes(delegate)}
                           className="text-blue-500 hover:text-blue-700 p-1 rounded-full hover:bg-blue-50 transition-colors"
                           title="عرض الملاحظات كاملة"
                         >
                           <FileText size={16} />
                         </button>
                       )}
                     </div>
                   </td>
                   <td className="px-6 py-4 border-b border-gray-200">
                     <div className="flex gap-3 justify-center">
                       <button
                         onClick={() => handleEdit(delegate)}
                         className="text-blue-600 hover:text-blue-800 p-1.5 hover:bg-blue-50 rounded-full transition duration-200"
                         title="تعديل"
                       >
                         <Edit size={18} />
                       </button>
                       <button
                         onClick={() => handleDelete(delegate.DelegateID)}
                         className="text-red-600 hover:text-red-800 p-1.5 hover:bg-red-50 rounded-full transition duration-200"
                         title="حذف"
                       >
                         <Trash2 size={18} />
                       </button>
                     </div>
                   </td>
                 </tr>
               ))}
             </tbody>
           </table>
         </div>
         <div className="md:hidden p-3 space-y-3">
           {filteredDelegates.map((delegate) => (
             <div key={delegate.DelegateID} className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
               <div className="h-1.5 bg-gradient-to-l from-blue-500 to-cyan-500" />
               <div className="p-4">
                 <div className="flex gap-3 items-start">
                   {delegate.DelegateImage ? (
                     <img src={delegate.DelegateImage} alt="صورة المندوب" onClick={() => handleImageClick(delegate.DelegateImage)} className="w-16 h-16 rounded-2xl object-cover shadow cursor-pointer shrink-0" />
                   ) : (
                     <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center shrink-0"><Camera size={24} className="text-gray-400" /></div>
                   )}
                   <div className="min-w-0 flex-1">
                     <h3 className="font-bold text-gray-900 break-words">{delegate.DelegateName}</h3>
                     <p className="text-sm text-gray-500 mt-1">{delegate.Title || 'بدون لقب'}</p>
                     <div className="flex flex-wrap gap-1 mt-2">
                       <span className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full">مندوب</span>
                       {delegate.PhoneNumber && <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">{delegate.PhoneNumber}</span>}
                     </div>
                   </div>
                 </div>
                 <div className="grid grid-cols-1 gap-2 text-sm mt-3">
                   <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">العنوان: </span><span className="font-medium break-words">{delegate.Address || '-'}</span></div>
                   <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">البريد: </span><span className="font-medium break-all">{delegate.Email || '-'}</span></div>
                   <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">ملاحظات: </span><span className="font-medium break-words">{truncateNotes(delegate.Notes)}</span></div>
                 </div>
                 <div className="grid grid-cols-3 gap-2 mt-3">
                   <button onClick={() => handleEdit(delegate)} className="bg-blue-50 text-blue-700 border border-blue-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><Edit size={15} /> تعديل</button>
                   <button onClick={() => setShowNotes(delegate)} disabled={!delegate.Notes} className="bg-amber-50 text-amber-700 border border-amber-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm disabled:opacity-50"><FileText size={15} /> ملاحظات</button>
                   <button onClick={() => handleDelete(delegate.DelegateID)} className="bg-red-50 text-red-700 border border-red-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><Trash2 size={15} /> حذف</button>
                 </div>
               </div>
             </div>
           ))}
         </div>
       </div>

       {/* Add/Edit Form Modal */}
       {showForm && (
         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-stretch md:items-center justify-center z-50 md:p-4">
           <div className="bg-white rounded-none md:rounded-xl shadow-2xl w-full md:max-w-3xl md:mx-4 overflow-hidden h-[100dvh] md:h-auto flex flex-col">
             <div className="p-4 md:p-6 border-b border-gray-200 shrink-0">
               <div className="flex justify-between items-center">
                 <h2 className="text-2xl font-bold text-gray-900">
                   {editingId ? 'تعديل بيانات المندوب' : 'إضافة مندوب جديد'}
                 </h2>
                 <button
                   onClick={resetForm}
                   className="text-gray-400 hover:text-gray-600 transition duration-200"
                 >
                   <X size={24} />
                 </button>
               </div>
             </div>
             
             <form onSubmit={handleSubmit} className="p-4 md:p-6 overflow-y-auto flex-1 pb-24 md:pb-6">
               <div className="space-y-6">
                 {/* Image Upload Section */}
                 <div>
                   <label className="block text-sm font-medium text-gray-700 mb-3">صورة المندوب</label>
                   <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                     {formData.DelegateImage ? (
                       <div className="relative">
                         <img 
                           src={formData.DelegateImage} 
                           alt="صورة المندوب"
                           className="w-28 h-28 md:w-44 md:h-44 object-cover rounded-2xl md:rounded-lg shadow-lg cursor-pointer"
                           onClick={() => handleImageClick(formData.DelegateImage)}
                         />
                         <button
                           type="button"
                           onClick={() => setFormData({...formData, DelegateImage: ''})}
                           className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1.5 hover:bg-red-600 transition duration-200"
                         >
                           <X size={18} />
                         </button>
                       </div>
                     ) : (
                       <div className="w-full sm:w-44 h-28 md:h-44 border-2 border-dashed border-gray-300 rounded-2xl md:rounded-lg flex flex-col items-center justify-center hover:bg-gray-50 transition-colors duration-200 cursor-pointer">
                         <label className="cursor-pointer flex flex-col items-center">
                           <Camera size={36} className="text-gray-400 mb-2" />
                           <span className="text-sm text-gray-600 font-medium">اختر صورة</span>
                           <span className="text-xs text-gray-400 mt-1">الحد الأقصى 1 ميجابايت</span>
                           <input
                             type="file"
                             accept="image/*"
                             className="hidden"
                             onChange={handleImageChange}
                           />
                         </label>
                       </div>
                     )}
                   </div>
                 </div>

                 {/* Form Fields */}
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                   <div>
                     <label className="block text-sm font-medium text-gray-700 mb-2">اسم المندوب</label>
                     <input
                       type="text"
                       value={formData.DelegateName}
                       onChange={(e) => setFormData({...formData, DelegateName: e.target.value})}
                       className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                       required
                     />
                   </div>

                   <div>
                     <label className="block text-sm font-medium text-gray-700 mb-2">اللقب</label>
                     <input
                       type="text"
                       value={formData.Title}
                       onChange={(e) => setFormData({...formData, Title: e.target.value})}
                       className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                       placeholder="اسم الشهره.."
                     />
                   </div>
                   
                   <div>
                     <label className="block text-sm font-medium text-gray-700 mb-2">رقم الهاتف</label>
                     <input
                       type="text"
                       value={formData.PhoneNumber}
                       onChange={(e) => setFormData({...formData, PhoneNumber: e.target.value})}
                       className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                     />
                   </div>
                   
                   <div>
                     <label className="block text-sm font-medium text-gray-700 mb-2">العنوان</label>
                     <input
                       type="text"
                       value={formData.Address}
                       onChange={(e) => setFormData({...formData, Address: e.target.value})}
                       className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                     />
                   </div>
                   
                   <div>
                     <label className="block text-sm font-medium text-gray-700 mb-2">البريد الإلكتروني</label>
                     <input
                       type="email"
                       value={formData.Email}
                       onChange={(e) => setFormData({...formData, Email: e.target.value})}
                       className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                     />
                   </div>

                   <div className="md:col-span-2">
                     <label className="block text-sm font-medium text-gray-700 mb-2">ملاحظات</label>
                     <textarea
                       value={formData.Notes}
                       onChange={(e) => setFormData({...formData, Notes: e.target.value})}
                       className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200 h-32 resize-none"
                       placeholder="أضف أي ملاحظات إضافية هنا..."
                     />
                   </div>
                 </div>

                 <div className="fixed md:static bottom-0 left-0 right-0 bg-white border-t p-3 md:p-0 flex flex-col-reverse md:flex-row justify-end gap-2 md:gap-4 mt-6 md:pt-6 md:border-t border-gray-200">
                   <button
                     type="submit"
                     className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 md:py-2.5 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200 ease-in-out md:transform md:hover:scale-105 w-full md:w-auto"
                   >
                     <Save size={20} />
                     {editingId ? 'تحديث البيانات' : 'حفظ البيانات'}
                   </button>
                   <button
                     type="button"
                     onClick={resetForm}
                     className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 md:py-2.5 rounded-xl md:rounded-lg transition duration-200 w-full md:w-auto"
                   >
                     إلغاء
                   </button>
                 </div>
               </div>
             </form>
           </div>
         </div>
       )}

       {/* Image Preview Modal */}
       {selectedImage && (
         <div 
           className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
           onClick={() => setSelectedImage(null)}
         >
           <div className="relative w-full h-full md:max-w-5xl md:max-h-[90vh] bg-white md:rounded-xl shadow-2xl overflow-hidden flex items-center justify-center">
             <img 
               src={selectedImage} 
               alt="صورة مكبرة"
               className="max-w-full max-h-full md:max-h-[85vh] object-contain p-2"
             />
             <button
               className="absolute top-4 right-4 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition duration-200 transform hover:scale-110"
               onClick={(e) => {
                 e.stopPropagation();
                 setSelectedImage(null);
               }}
             >
               <X size={24} />
             </button>
           </div>
         </div>
       )}

       {/* Notes Preview Modal */}
       {showNotes && (
         <div 
           className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
           onClick={() => setShowNotes(null)}
         >
           <div 
             className="bg-white rounded-none md:rounded-xl shadow-2xl w-full h-[100dvh] md:h-auto md:max-w-2xl md:mx-4 p-4 md:p-6 overflow-y-auto"
             onClick={e => e.stopPropagation()}
           >
             <div className="flex justify-between items-center mb-4">
               <h3 className="text-xl font-bold text-gray-900">
                 ملاحظات المندوب: {showNotes.DelegateName}
               </h3>
               <button
                 onClick={() => setShowNotes(null)}
                 className="text-gray-400 hover:text-gray-600 transition duration-200"
               >
                 <X size={24} />
               </button>
             </div>
             <div className="bg-gray-50 rounded-lg p-4 min-h-[100px] max-h-[400px] overflow-y-auto">
               {showNotes.Notes || 'لا توجد ملاحظات'}
             </div>
             <div className="mt-4 flex justify-end">
               <button
                 onClick={() => setShowNotes(null)}
                 className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-2.5 rounded-lg transition duration-200"
               >
                 إغلاق
               </button>
             </div>
           </div>
         </div>
       )}

       {/* Empty State */}
       {filteredDelegates.length === 0 && (
         <div className="bg-white rounded-lg shadow-md p-8 text-center">
           <Camera size={48} className="mx-auto text-gray-400 mb-4" />
           <h3 className="text-lg font-medium text-gray-900 mb-2">لا يوجد مناديب</h3>
           <p className="text-gray-500 mb-4">لم يتم إضافة أي مناديب حتى الآن، يمكنك إضافة مندوب جديد من خلال الزر أعلاه.</p>
           <button 
             onClick={() => setShowForm(true)}
             className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg inline-flex items-center gap-2 transition duration-200"
           >
             <Plus size={20} />
             إضافة مندوب جديد
           </button>
         </div>
       )}
     </div>
   </div>
 );
};

export default DelegateManagement;